import React, { Component } from 'react';

export default class Head extends Component {
	render() {
		return <div style={{}}>		
			<img src={require('./img/name.png')} style={{
				position:"absolute",
				left: 24,
				top: 32,
				width:30,
				height:30,
				borderRadius:15
			}} />
			<div style={{
				position:"absolute",
				left: 24,
				top: 96,
				width:360 - 48,
				height:100,
	
			}}>
				<span style={{
					fontWeight:"bold"	
				}}>Name</span>
				<br/>
				<br/>
				<span style={{	
					fontSize:16
				}}>Adding your name allows your phone to personalize some apps.</span>
				<br/>
				<br/>
				<br/>
				<div style={{
					position:"absolute",
					top:108,
					width: 300,
					height: 48,					
				}}>
					<span style={{
						color:global.blue,
						fontSize:14
					}}>Name</span>
					<br/>
					<input style={{
						fontSize: 16,
						marginTop:4,					
					}} value='"My Name"' placeholder="e.g. Joe Smith"/>
					<div style={{
						width: "100%",
						height:1,
						position:"absolute",
						bottom:0,
						backgroundColor:"grey",
						opacity:0.3					
					}} />
				</div>
			</div>
			
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/Name.js